export const colorPrimary: string = '#001c3d'
export const backgroundColor: string = '#eff6ff'

export const colorSecondary: string = '#003b81'

export const colorText: string = 'black'
export const colorTextSecondary: string = 'white'